import * as React from "react";
import PropTypes from "prop-types";
import { Field, Control, Input, Label } from "rbx";
import { useCompanyParameters } from "../../utils/hooks";

function PrintBarcodeForm({ inputs, disabled, onChange }) {
  const { data: CompanyParameters } = useCompanyParameters();

  const usePrimaryDim = CompanyParameters?.UsePrimaryStorageDimension;
  const useSecondaryDim = CompanyParameters?.UseSecondaryStorageDimension;
  const useTertiaryDim = CompanyParameters?.UseTertiaryStorageDimension;

  const primaryDim =
    CompanyParameters?.PrimaryStorageDimension?.CodeDescription || "";
  const secondaryDim =
    CompanyParameters?.SecondaryStorageDimension?.CodeDescription || "";
  const tertiaryDim =
    CompanyParameters?.TertiaryStorageDimension?.CodeDescription || "";

  return (
    <React.Fragment>
      <Field className="grid-override is-three" kind="group">
        <Control expanded style={{ gridColumn: "span 2" }}>
          <Label>Item Number</Label>
          <Input
            disabled={disabled}
            name="ItemNo"
            type="text"
            value={inputs.ItemNo}
            onChange={e => onChange(e.target.name, e.target.value)}
          />
        </Control>
        <Control>
          <Label>Quantity</Label>
          <Input
            disabled={disabled}
            name="Multiplier"
            type="number"
            value={inputs.Multiplier}
            onChange={e => onChange(e.target.name, e.target.value)}
          />
        </Control>
      </Field>
      <Field className="grid-override is-three" kind="group">
        {usePrimaryDim && (
          <Control expanded>
            <Label>{primaryDim}</Label>
            <Input
              disabled={disabled}
              name="Dim1"
              type="text"
              value={inputs.Dim1}
              onChange={e => onChange(e.target.name, e.target.value)}
            />
          </Control>
        )}
        {useSecondaryDim && (
          <Control expanded>
            <Label>{secondaryDim}</Label>
            <Input
              disabled={disabled}
              name="Dim2"
              type="text"
              value={inputs.Dim2}
              onChange={e => onChange(e.target.name, e.target.value)}
            />
          </Control>
        )}
        {useTertiaryDim && (
          <Control expanded>
            <Label>{tertiaryDim}</Label>
            <Input
              disabled={disabled}
              name="Dim3"
              type="text"
              value={inputs.Dim3}
              onChange={e => onChange(e.target.name, e.target.value)}
            />
          </Control>
        )}
      </Field>
    </React.Fragment>
  );
}

PrintBarcodeForm.propTypes = {
  inputs: PropTypes.object,
  disabled: PropTypes.bool,
  onChange: PropTypes.func
};
PrintBarcodeForm.defaultProps = {
  inputs: {},
  disabled: false,
  onChange: () => {}
};
export default PrintBarcodeForm;
